<template>
    <div id="app">
       <a-config-provider :locale="locale">
			<router-view class="appView"></router-view>
       </a-config-provider>
    </div>
</template>

<script>
    import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
    import en_GB from 'ant-design-vue/lib/locale-provider/en_GB';
    import moment from 'moment';
    import 'moment/locale/zh-cn';
    moment.locale('zh-cn');
	export default {
		data() {
			return {
				zh_CN,
				en_GB,
				locale: {}
			};
		},
		watch: {
			$route() {
      			this.$store.dispatch('setSelectedKeys', this.$route.meta.permCode)
				if(this.$route.meta.permCode) {
					this.$store.dispatch('setOpenKeys', this.$route.meta.permCode.substr(0, 2))
				}
			}
		},
		created() {
			// 初加载、刷新时更新语言
			this.locale = this.$cookieStore.getCookie("languageType") == "zh" ? this.zh_CN : this.en_GB
			this.$i18n.locale = this.$cookieStore.getCookie("languageType") == "zh" ? "zh" : 'en'
			this.$cookieStore.setCookie('languageType', this.$i18n.locale)
		},
		mounted() {
			// 切换语言
			this.$root.eventHub.$on('languagesChange', ()=> {
				this.locale =  this.$cookieStore.getCookie("languageType") == "zh" ? this.zh_CN : this.en_GB
			})
			// 检测浏览器路由改变页面不刷新问题,hash模式的工作原理是 hashchange事件
			window.addEventListener('hashchange', () => {
				let currentPath = window.location.hash.slice(1)
				if (this.$route.path !== currentPath) {
					this.$router.push(currentPath)
				}
			}, false)
		}
	}
</script>

<style lang="scss">
.appView {
  position: absolute;
  width:100%;
  transition: transform 1.3s ease-out;
}
.slide-left-enter{
  transform: translate(100%, 0);
}
.slide-left-leave-active{
  transform: translate(-50%, 0);
}
.slide-right-enter {
  transform: translate(-50%, 0);
}
.slide-right-leave-active{
  transform: translate(100%, 0);
}
</style>
